<template>
    <div style="width:100%" :class="{ right: direction==='right',left:direction!=='right' }">
        <div ref="wrapper" class="bg-white wrapper"
             style="width:100%;overflow: hidden;padding-top: 50%;position: relative;box-sizing: border-box;border:0px;transition: all .6s;transition-timing-function:ease-out">
            <!--			TOP-->
            <div ref="topWrapper" class="origin bg-white"
                 style="width:100%;;padding-top: 50%;overflow: hidden;z-index: 300;cursor: pointer"
                 @click="click">
                <div ref="photo" class="origin bg-cover trans-opacity"
                     style="width:100%;padding-top:50%;z-index: 200;opacity: 0"></div>
                <div ref="thumb" class="origin trans-opacity thumb"
                     style="width:50%;padding-top:50%;background-size: cover;background-position: center;opacity: 1;z-index: 300"></div>

                <div ref="titleBox" class="title-box origin full-size"
                     style="z-index: 400; transition: all .6s;transition-timing-function:ease-out">
                    <div class="triangle" style="position:absolute;top:10%;right:50%;width:5%;height:10%">
                        <!--	                    TRIANGLE-->
                        <svg class="fill-white" height="100%" width="100%" viewBox="0 0 100 100">
                            <polygon points="100,0 50,50 100,100"/>
                        </svg>
                    </div>
                    <div class="bg-white title-text uppercase"
                         style="box-sizing:border-box;position:absolute;width:50%;height:100%;right:0px;top:0px;padding:5%;">
                        <div class="font-gold font-name" style="padding-bottom:5%">
                            {{name}}
                        </div>
                        <div class="font-subtitle font-grey">
                            {{title}}
                        </div>
                    </div>
                    <!--					PLUS BUTTON-->
                    <!--                    <div style="position:absolute;right:5%;bottom:10%;z-index:500">-->
                    <!--                        <svg height="15" width="15">-->
                    <!--                            <rect x="7" width="1" height="15" style="fill:#888888"/>-->
                    <!--                            <rect y="7" width="15" height="1" style="fill:#888888"/>-->
                    <!--                        </svg>-->
                    <!--                    </div>-->
                </div>
                <div ref="plusBtn"
                     :class="{ rotate45: opened }"
                     class="plus-btn"
                     style="position:absolute;bottom:10%;z-index:600;transition:all 1s">
                    <svg height="15" width="15">
                        <rect x="7" width="1" height="15" style="transition: fill 1s;"/>
                        <rect y="7" width="15" height="1" style="transition: fill 1s;"/>
                    </svg>
                </div>
            </div>
            <div ref="titleBar"
                 style="
			position:absolute;
			transition:all .5s;
			z-index: 200;
			width:100%;" class="">
                <div class="uppercase bg-gold font-name" ref=""
                     style="
					width:100%;
					padding:10px;
					box-sizing: border-box;
					color:white">
                    {{name}}
                </div>
                <div>
                    <div class="fill-gold"
                         style="width:30px;height:15px;margin:auto">
                        <!--	                    TRIANGLE-->
                        <svg height="100%" width="100%" viewBox="0 0 100 50">
                            <polygon points="0,0 50,50 100,0"/>
                        </svg>
                    </div>
                </div>

            </div>

            <div ref="describe" class="origin trans-opacity white"
                 style="transition:all 1s;position:absolute; padding:30px;padding-bottom:40px;box-sizing: border-box; opacity: 0;z-index: 100;text-align: left">
                <!--                title-->
                <div class="uppercase font-title">{{title}}</div>
                <div class="uppercase font-subtitle"
                     style="padding-top: 5px;padding-bottom: 15px;border-bottom: 1px solid #cccccc;margin-bottom: 15px;" v-html="subtitle">
<!--                    {{subtitle}}-->
                </div>

                <div class="font-content" v-html="details">
<!--                    {{details}}-->
                </div>
                <div style="text-align: right;padding-top:20px" v-if="web && web.length>5"><a :href="web" class="font-subtitle font-grey">VISIT WEBSITE</a></div>

            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "ArrowCard",
		data() {
			return {
				opened: false
			};
		},
		props: {
			direction: String,
			name: String,
			title: String,
			subtitle: String,
			details: String,
			thumb: String,
			photo: String,
            web: String,
			more: String
		},
		mounted() {
			this.$refs.thumb.style.backgroundImage = "url(" + this.thumb + ")";
			this.$refs.photo.style.backgroundImage = "url(" + this.photo + ")";
		},
		methods: {
			click() {
				let titleBox = this.$refs.titleBox;
				let photo = this.$refs.photo;
				let thumb = this.$refs.thumb;
				let topWrapper = this.$refs.topWrapper;
				let titleBar = this.$refs.titleBar;
				let describe = this.$refs.describe;
				let wrapper = this.$refs.wrapper;
				this.opened = !this.opened;

				let topHeight = topWrapper.clientHeight;
				let titleBarHeight = titleBar.clientHeight;
				let describeHeight = describe.clientHeight;

				if (this.opened) {
					titleBox.style.left = (this.direction === 'right' ? -1 : 1) * 55 + '%';
					photo.style.opacity = '1';
					thumb.style.opacity = '0';

					wrapper.style.height = topHeight + "px";
					setTimeout(() => {
						wrapper.style.height = (topHeight + titleBarHeight + describeHeight) + "px";
						describe.style.opacity = '1';
						titleBar.style.top = topHeight + "px";
					}, 300);
					// titleBar.style.bottom = topHeight - titleBarHeight + "px";
					describe.style.top = topHeight + titleBarHeight + "px";
					titleBar.style.top = topHeight - 50 + "px";
				} else {
					titleBox.style.left = '0px';
					photo.style.opacity = '0';
					thumb.style.opacity = '1';

					setTimeout(() => {
						wrapper.style.height = topHeight + "px";
						describe.style.opacity = '0';
						describe.style.top = '0px';
						titleBar.style.top = topHeight - 50 + "px";
					}, 300);
				}

			}
		}
	}
</script>

<style scoped>


    .trans-opacity {
        transition: opacity 2s;
    }

    .white {
        background-color: #eeeeee;
    }

    .border {
        border: 1px solid red;
    }



    .flex-center {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .plus-btn rect {
        fill: #666666;
    }

    .rotate45 {
        transform: rotate(45deg);
    }

    .rotate45 rect {
        fill: white;
    }

    .right .thumb {
        left: auto;
        right: 0px;
    }

    .right .title-text {
        left: 0px;
    }

    .right .triangle {
        transform: scaleX(-1);
        left: 50%;
    }
    .right .title-box{
        text-align: right
    }

    .right .plus-btn {
        left: 5%;
    }

    .left .plus-btn {
        right: 5%;
    }
    .left .title-box{
        text-align: left
    }

</style>